import { useSyncExternalStore } from "react";
import { MOCK_SCREENING_CONFIGS, type ScreeningConfig } from "./_data";

/**
 * Saved ScreeningConfig presets — shared between settings/Search Parameters
 * tab (the editor) and screening / monitoring surfaces (the consumers).
 *
 * Phase 2 swaps the module-local `configs` for a TanStack-Query / Axios
 * pair against the backend's settings endpoint; for now it's a
 * useSyncExternalStore-backed in-memory store seeded with MOCK data.
 *
 * The store is intentionally session-scoped (no persistence) — saved
 * parameters survive page navigation within a session, get reset on
 * reload. Matches Ignacio's app-v2 implementation.
 */

let configs: ScreeningConfig[] = [...MOCK_SCREENING_CONFIGS];
const listeners = new Set<() => void>();

function emit() {
  for (const l of listeners) l();
}

function getSnapshot() {
  return configs;
}

export function setScreeningConfigs(next: ScreeningConfig[]) {
  configs = next;
  emit();
}

export function useScreeningConfigs(): ScreeningConfig[] {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    getSnapshot,
    getSnapshot,
  );
}
